import { Component, Input, OnInit } from '@angular/core';
import { Contact } from '../../models/contact/contact';

@Component({
  selector: 'app-statistics-job-list',
  templateUrl: './statistics-job-list.component.html',
  styleUrl: './statistics-job-list.component.css'
})
export class StatisticsJobListComponent implements OnInit {
  @Input({required: true}) nameList: string[];
  @Input({required: true}) contact: Contact;
  @Input({required: true}) opened: boolean;

  collapsed: boolean;
  
  ngOnInit(): void {
    this.collapsed = !this.opened;
  }
}
